type HapticType = 'success' | 'error' | 'warning' | 'heavy' | 'light'

export const haptic = (type: HapticType) => {
  try {
    const tg = window.Telegram?.WebApp?.HapticFeedback
    if (!tg) return

    switch (type) {
      case 'success':
        tg.notificationOccurred('success')
        break
      case 'error':
        tg.notificationOccurred('error')
        break
      case 'warning':
        tg.notificationOccurred('warning')
        break
      case 'heavy':
        tg.impactOccurred('heavy')
        break
      case 'light':
        tg.impactOccurred('light')
        break
    }
  } catch {
    // Haptic not available on this platform
  }
}
